class TempVerifyRequest {
    TempVerifyURL(trx){
        return process.env.REACT_APP_BASEURL+"TempVerify/"+trx
    }
}
export const {TempVerifyURL}=new TempVerifyRequest();